// extracted by mini-css-extract-plugin
module.exports = {"load-more":"styles-m__load-more__XqzY-","arrow":"styles-m__arrow__2Zjqr","wrapper":"styles-m__wrapper__2t1qa"};